import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { Capacitor } from "@capacitor/core";
import { doc, getDoc } from "firebase/firestore";

import { White, White05, White08 } from "../../theme/colors";
import { P1 } from "../../theme/text/Headings";
import { useAuth } from "../../../services/AuthContext";
import { db } from "../../../services/firebase.config";
import dataCache from "../../../services/DataCache";

const TabContainer = styled.div`
  display: flex;
  border-radius: 20px;
  padding: 3px;
  height: 36px;
  align-items: center;
`;

const Tab = styled.div`
  position: relative;
  padding: 5px 16px 0px;
  border-radius: 17px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 18px;
  font-weight: 900;
  color: ${(props) => (props.$active ? White : White05)};
  min-width: 60px;
  text-align: center;
  user-select: none;
`;

const TabSwitcher = ({ activeTab, onTabChange }) => {
  const { currentUserState } = useAuth();
  const [displayName, setDisplayName] = useState("");

  useEffect(() => {
    const fetchDisplayName = async () => {
      if (!currentUserState?.uid) return;

      const profileKey = `user-profile-${currentUserState.uid}`;
      let profileData = dataCache.get(profileKey);

      if (!profileData) {
        try {
          const profileDocRef = doc(
            db,
            "public-profiles",
            currentUserState.uid
          );
          const profileDoc = await getDoc(profileDocRef);
          profileData = profileDoc.exists() ? profileDoc.data() : null;
          if (profileData) {
            dataCache.set(profileKey, profileData, 5 * 60 * 1000);
          }
        } catch (e) {
          console.warn("Failed to fetch profile:", e);
        }
      }

      if (profileData?.displayName) {
        setDisplayName(profileData.displayName);
      }
    };

    fetchDisplayName();
  }, [currentUserState]);

  const handleTabClick = async (tab) => {
    if (tab !== activeTab && Capacitor.isNativePlatform()) {
      try {
        await Haptics.impact({ style: ImpactStyle.Light });
      } catch (e) {
        console.warn("Tab haptics failed:", e);
      }
    }
    onTabChange(tab);
  };

  return (
    <TabContainer>
      <Tab
        $active={activeTab === "quiz"}
        onClick={() => handleTabClick("quiz")}
      >
        <P1 color={White08}>Welcome{displayName ? `, ${displayName}` : ""}!</P1>
      </Tab>
      {/* <Tab
        $active={activeTab === "insights"}
        onClick={() => handleTabClick("insights")}
      >
        Daily
      </Tab> */}
    </TabContainer>
  );
};

export default TabSwitcher;
